import { render } from "./StationSimpleInfo.vue?vue&type=template&id=73ce4fe6&scoped=true"
import script from "./StationSimpleInfo.vue?vue&type=script&lang=js"
export * from "./StationSimpleInfo.vue?vue&type=script&lang=js"

import "./StationSimpleInfo.vue?vue&type=style&index=0&id=73ce4fe6&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73ce4fe6"]])

export default __exports__